<template>
  <i-container class="_align-self:stretch">
    <i-row around middle class="_height:100%">
      <i-column lg="4" md="6" sm="7">
        <i-card>
          <template #header>Invites</template>
          <i-form-label>Name</i-form-label>
          <i-input v-model="name" />
          <i-form-label class="_padding-top:1/2">Role</i-form-label>
          <i-select
            v-if="roles"
            v-model="chosenRole"
            :options="roles"
            placeholder="Choose something.."
          />
          <i-button
            class="_margin-top:1 _width:100%"
            type="submit"
            :disabled="!name || !chosenRole"
            :color="!name || !chosenRole ? '' : 'primary'"
            @click="sendInvites"
          >
            Submit
          </i-button>
          <template v-if="url">
            <i-form-label class="_padding-top:1/2">Link</i-form-label>
            <i-input  v-model="url" ref="url" />
          </template>
        </i-card>

      </i-column>
    </i-row>
  </i-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      name: null,
      roles: null,
      chosenRole: null,
      url: null
    }
  },
  computed: {
    ...mapState(['api'])
  },
  methods: {
    ...mapMutations('notifications', ['addNotification']),
    async sendInvites () {
      const resp = await this.$store.dispatch('sendInvites', {
        name: this.name,
        role: this.chosenRole.label
      })
      if (resp && resp.code) {
        this.url = `${this.api.siteUrl}/sign-up/${resp.code}`
        navigator.clipboard.writeText(this.url)
        this.addNotification({
          notification: {
            type: 'success',
            message: 'Link copied to clipboard'
          }
        })
      }
    }
  },
  async mounted () {
    const roles = await this.$store.dispatch('getRoles')
    this.roles = roles.map((el, index) => {
      return { id: index, label: el }
    })
  }
}
</script>
